module.exports = __webpack_public_path__ + "static/media/icon_58.4a4f89ea.svg";